import * as React from "react"
import { toast } from "react-toastify"
import { Button, Stack, Typography } from "@mui/material"

const DEFAULT_SUCCESS = "Done!"

function ConfirmContent({ message, onSubmit, onCancel, closeToast }) {
    return (
        <Stack spacing={1.5}>
            <Typography variant="body2">{message}</Typography>
            <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Button
                    size="small"
                    variant="outlined"
                    onClick={() => { closeToast(); onCancel?.() }}
                >
                    Cancel
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    onClick={() => { closeToast(); onSubmit?.() }}
                >
                    Confirm
                </Button>
            </Stack>
        </Stack>
    )
}

export default function useToastSeeker() {
    const showToast = {
        success: (msg, config = {}) => toast.success(msg, config),
        error: (msg, config = {}) => toast.error(msg, config),
        info: (msg, config = {}) => toast.info(msg, config),
        warning: (msg, config = {}) => toast.warning(msg, config),
        promise: (callback, { pending, success, error, onPending, onSuccess, onFinish, ...config } = {}) =>
            toast.promise(
                callback.then((res) => res).finally(() => onFinish && onFinish()),
                {
                    pending: { render: () => (onPending ? onPending() || pending : pending) || "Loading..." },
                    success: { render: (res) => (onSuccess ? onSuccess(res.data) || success : success) || DEFAULT_SUCCESS },
                    error: { render: () => error || "An error occurred" },
                },
                config
            ),
        confirm: (message, { onSubmit, onCancel, ...config } = {}) =>
            toast(
                ({ closeToast }) => (
                    <ConfirmContent
                        message={message}
                        onSubmit={onSubmit}
                        onCancel={onCancel}
                        closeToast={closeToast}
                    />
                ),
                { autoClose: false, closeOnClick: false, ...config }
            ),
    }
    return { showToast }
}
